import React from 'react';
import docx from '../icons/docx.svg';
import pdf from '../icons/pdf.svg';
import trash from '../icons/trash.svg';
import jpg from '../icons/jpg.svg';
import anyfile from '../icons/anyfile.svg';
import xls from '../icons/xls.svg';
import xlsx from '../icons/xlsx.svg';
import tiff from '../icons/tiff.svg';
import mp4 from '../icons/mp4.svg';
import bmp from '../icons/bmp.svg';
import png from '../icons/png.svg';
export const UploadedDocumentCards = ({ docs, indexOfFileSection, handleRemoveFile }) => {
    return (
        <>
            <div className='m-2' key={"uploaded_" + indexOfFileSection} >
                {docs && docs['Document_Value'].length > 0 && (
                    <div><strong className='poonawalla-color'>Selected documents:</strong></div>
                )}
                {docs && docs['Document_Value'].map((docsfile, index) => {
                    let extension = docsfile?.name;
                    extension = extension ? extension.split(".") : "";
                    extension = extension ? extension[(extension.length - 1)] : "";

                    return (
                        <div key={"uploaded_List_" + index} className='row div-rounded col-xl-4 col-lg-4 col-md-10 col-sm-12 col-12'>
                            <div className='col-4 col-sm-4 col-md-4 col-lg-3 col-xl-3 text-left'>
                                {extension && extension === "pdf" ? (
                                    <img className='icons' src={pdf} alt="a" />
                                ) : extension === "jpg" ? (
                                    <img className='icons' src={jpg} alt="a" />
                                ) : extension === "docx" ? (
                                    <img className='icons' src={docx} alt="a" />
                                ) : extension === "xlsx" ? (
                                    <img className='icons' src={xlsx} alt="a" />
                                ) : extension === "xls" ? (
                                    <img className='icons' src={xls} alt="a" />
                                ) : extension === "tiff" ? (
                                    <img className='icons' src={tiff} alt="a" />
                                ) : extension === "mp4" ? (
                                    <img className='icons' src={mp4} alt="a" />
                                ) : extension === "bmp" ? (
                                    <img className='icons' src={bmp} alt="a" />
                                ) : extension === "png" ? (
                                    <img className='icons' src={png} alt="a" />
                                ) : (
                                    <img className='icons' src={anyfile} alt="a" />
                                )}

                            </div>
                            <div className='col-4 col-sm-4 col-md-4 col-lg-6 col-xl-6 text-left'>{docsfile?.name}</div>
                            <div className='col-4 col-sm-4 col-md-4 col-lg-3 col-xl-3 text-end'>
                                <img className='icons text-right text-danger' onClick={(e) => handleRemoveFile(indexOfFileSection, index)} src={trash} alt="b" />
                            </div>
                        </div>
                    )
                })}
            </div>
        </>

    )
}
